export default "__VITE_ASSET__d0b1b9db__$_?react__"